import { isFlightControlPanelEnabled } from '@ms/yammer-data/dist/domains/flightControlPanel/selectors';

import { useSelector } from '../useSelector';

type UseIsFlightControlPanelEnabled = () => ReturnType<typeof isFlightControlPanelEnabled>;
export const useIsFlightControlPanelEnabled: UseIsFlightControlPanelEnabled = () =>
  useSelector((state) => isFlightControlPanelEnabled(state));
